<div class="card">
  <p-card>
    <input pInputText type="text" [(ngModel)]="data.displayName" placeholder="Display name" />
    <input pInputText type="text" [(ngModel)]="data.email" placeholder="Email" />
    <p-select [options]="roles" appendTo="body" [(ngModel)]="data.role" />
  </p-card>
  <p-card>
    <input pInputText type="password" [(ngModel)]="data.password" placeholder="Password" />
    <input pInputText type="password" [(ngModel)]="data.confirmPassword" placeholder="Password" />
  </p-card>
</div>
<div class="card">
  <p-card header="Actions">
    <p-button label="save" icon="pi pi-plus" (click)="Save()" severity="secondary" />
    <p-button label="cansle" icon="pi pi-plus" (click)="Cansle()" severity="secondary" />
  </p-card>
</div>
